import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/writing', label: 'Research & Writing' },
    { path: '/consulting', label: 'Consulting' },
    { path: '/protocol-checker', label: 'Protocol Checker' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-slate-200" data-testid="navbar">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
            <span className="font-['Montserrat'] font-bold text-xl text-[#2C3E50]">
              Siddharth Kaul
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#3498DB] ${
                  isActive(link.path) ? 'text-[#3498DB]' : 'text-[#2C3E50]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Button
              asChild
              className="bg-[#3498DB] hover:bg-[#2980B9] text-white shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]"
              data-testid="nav-book-consultation"
            >
              <a href="https://calendly.com/siddharthkaul" target="_blank" rel="noopener noreferrer">Book Consultation</a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-[#2C3E50]"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-slate-200" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`text-base font-medium py-2 transition-colors duration-200 hover:text-[#3498DB] ${
                    isActive(link.path) ? 'text-[#3498DB]' : 'text-[#2C3E50]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Button
                asChild
                className="bg-[#3498DB] hover:bg-[#2980B9] text-white w-full mt-2"
              >
                <a href="https://calendly.com/siddharthkaul" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)}>Book Consultation</a>
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
